import _get from 'lodash/get'
import kebabCase from 'lodash/kebabCase'
import { NotificationSettingsData } from 'components/Settings/AlertType/AlertType'
import { alertTypeDefaultFrequency } from 'components/Settings/ManageReceivers/ManageReceivers'
import appState from 'config/store/AppState'

const DEFAULT_ALERTS = [
  'Performance Breakdown Alert',
  'Missed Call Alert',
  'En Route Alert',
  'First Opportunity Alert',
  'New Appointment Call Alert',
  'New Opportunity Call Alert',
]

export const processReceiversSettingsData = (
  notifications: any[],
  contactRecords: any[]
): Map<string, NotificationSettingsData> => {
  const notificationRecords = new Map()

  notifications.forEach((item) => {
    const alertType = _get(item, 'Alert_Type__c')
    const key = kebabCase(alertType + '-' + _get(item, 'Contact__r.Id'))
    const method = _get(item, 'Method__c') ?? []
    const email = method.includes('Email')
    const sms = method.includes('SMS')
    const value = {
      id: item.Id,
      contactId: _get(item, 'Contact__r.Id'),
      name: _get(item, 'Contact__r.MVP_Name__c'),
      emailAddress: _get(item, 'Contact__r.Email'),
      phoneNumber: _get(item, 'Contact__r.Phone'),
      alertType: alertType,
      frequency: _get(item, 'Frequency__c'),
      email: email,
      sms: sms,
    }
    notificationRecords.set(key, value)
  })

  // Ensure that user has default alert settings if no settings exist. This is important for TCs opening the app through Salesforce 'CUSTOMER DASHBOARD' button. TCs may not have any alert settings for the account they are accessing.

  const userRecords = new Map(
    DEFAULT_ALERTS
      .filter(alertType => {
        return !notifications.some(n => 
          _get(n, 'Alert_Type__c') === alertType && 
          _get(n, 'Contact__r.Id') === appState.contactId
        )
      })
      .map(alertType => {
        const key = kebabCase(`${alertType}-${appState.contactId}`)
        return [
          key,
          createDefaultRecord(
            appState.contactId,
            appState.profileName,
            alertType,
            appState.email,
            appState.phone,
          ),
        ]
      })
  )

  // Create default records for each contact
  const defaultRecords = new Map(
    contactRecords.flatMap(contact =>
      DEFAULT_ALERTS.map(alertType => {
        const key = kebabCase(`${alertType}-${contact.id}`)
        return [
          key,
          createDefaultRecord(
            contact.id,
            contact.name,
            alertType,
            contact.email,
            contact.phone,
          ),
        ]
      })
    )
  )

  // notificationRecords will override userRecords and defaultRecords if there are any conflicts
  return new Map([...userRecords, ...defaultRecords, ...notificationRecords])
}

function createDefaultRecord(
  contactId: string,
  name: string,
  alertType: string,
  email?: string,
  phone?: string,
): NotificationSettingsData {
  return {
    id: '',
    contactId,
    name,
    alertType,
    frequency: alertTypeDefaultFrequency[alertType],
    email: false,
    sms: false,
    emailAddress: email,
    phoneNumber: phone,
  }
}
